module.exports = __webpack_public_path__ + "static/img/student_1.828072f8.png";